var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-100 vertical-flex-container" }, [
    _c("div", { staticClass: "vertical-flex-auto" }, [
      _c(
        "div",
        { staticClass: "row no-gutters mb-2" },
        [
          _c("direct-to-lender-navigation", {
            attrs: { page: _vm.currentPage },
            on: { "page-change": _vm.handlePageChange },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "mortgageContainer",
        staticClass: "pr-1 vertical-flex-fit",
        attrs: { id: "app-data-container" },
      },
      [
        _c(
          "div",
          {
            ref: "form",
            staticClass: "h-100",
            attrs: { id: "application-form" },
          },
          [
            _c(
              "div",
              { staticClass: "col-12 h-100", attrs: { id: _vm.currentPage } },
              [
                _c(
                  "div",
                  [
                    _c(
                      "keep-alive",
                      { attrs: { include: "LenderSubmit" } },
                      [
                        _c(_vm.currentPageComponent, {
                          tag: "component",
                          attrs: {
                            "application-id": _vm.applicationId,
                            "client-username": _vm.clientUsername,
                            "agent-username": _vm.agentUsername,
                          },
                          on: {
                            "direct-save": _vm.saveApplication,
                            "page-change": _vm.handlePageChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }